var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeTime = function SvgIconBadgeTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_badge_time_svg__a",
    width: "133.3%",
    height: "133.3%",
    x: "-16.7%",
    y: "-16.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D74141",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon_badge_time_svg__a)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.205 4.412c-.57 0-1.027-.429-1.027-.956 0-.528.456-.956 1.027-.956h3.993c.456 0 .913.428.913.956 0 .527-.457.956-.913.956h-1.141v1.87a7.63 7.63 0 0 1 3.651 1.531l.342-.37c.343-.374 1.027-.374 1.37 0 .342.374.342.978 0 1.351l-.343.371c.799 1.087 1.37 2.408 1.483 3.848h1.027c.457 0 .913.429.913.956 0 .529-.456.956-.913.956H18.56c-.57 3.716-3.65 6.575-7.53 6.575-4.221 0-7.53-3.423-7.53-7.646 0-3.94 2.966-7.183 6.732-7.601V4.412zm7.53 9.442c0 3.167-2.51 5.734-5.705 5.734-3.08 0-5.704-2.567-5.704-5.734 0-3.168 2.624-5.736 5.704-5.736 3.195 0 5.705 2.568 5.705 5.736M8.52 11.266a.844.844 0 0 1 1.255 0l1.94 1.912c.342.373.342.978 0 1.352-.343.373-.913.373-1.37 0L8.52 12.617c-.456-.373-.456-.977 0-1.35"
  })))));
};
export default SvgIconBadgeTime;